import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isShowInSmallScreen }) => ({
  ...($isShowInSmallScreen ? { display: "none" } : { display: "flex" }),
  flexDirection: "column",
  gap: 15,

  [theme.down("lg")]: {
    ...($isShowInSmallScreen ? { display: "flex" } : { display: "none" }),
  },
}));

export const CancelButton = styled("button")(({ theme, $isLoading }) => ({
  border: "none",
  borderRadius: 4,
  backgroundColor: theme.palette.error,
  color: theme.palette.white,
  fontSize: 20,
  transition: "all .3s ease-out",
  height: 46,
  width: "100%",
  cursor: "pointer",

  ...($isLoading
    ? {}
    : {
        "&:hover": {
          backgroundColor: theme.palette.errorDark,
        },
      }),
}));
